import styled from 'styled-components'

export const PageContentContainer = styled.div`
  width: 100%;
  max-height: calc(100vh - 72px);
  overflow-y: hidden;
`
